import React from "react";
import {useQueryFilter, useSetIdDip} from "@components/dataTable/customHooks";
import {usePagination} from "@components/dataTable/usePagination";
import {RMLLavoratoreFilterSelection, useGetRetribuzioniQuery, useLazyGetRetribuzioniQuery} from "@commons/features/lavoratore/RMLLavoratore.api";
import DettaglioRetribuzione from "./comps/DettaglioRetribuzione";
import TabellaMensileRML from "./comps/TabellaMensilita";
import {TabProps} from "../Lavoratori.retrib.page";
import TooltipEx from "../../../components/Tooltip";
import {export2excel} from "../../../features/export";

export const TabFlat: React.FC<TabProps> = ({editor, dettagliContratto, retribOraria, toggleRetribOraria}) => {
    const pagination = usePagination('',1, 10);
    const {filter, setFilter, skip} = useQueryFilter<RMLLavoratoreFilterSelection>({soloVariazioni: false} as RMLLavoratoreFilterSelection, pagination);

    const soloVariazioni = (filter && filter.soloVariazioni) ? filter.soloVariazioni : false;

    const {resource, cancel, URI, loadResource} = editor;

    useSetIdDip(dettagliContratto, setFilter, cancel);

    const toggleVariazioni = (v: boolean) => {
        setFilter(filter => ({
            ...filter, soloVariazioni: v
        }));
        pagination.setPage(1);
    }
    const skipOption = {skip: skip || !filter || !filter.idDip};
    const {data: retribuzioneFlat} = useGetRetribuzioniQuery(filter, skipOption);

    const [exportTrigger, {isLoading: exportIsLoading, isFetching: exportIsFetching}] = useLazyGetRetribuzioniQuery();
    const exportRML = () => export2excel(exportTrigger, filter, 'Elenco RML');

    return <>
        {resource && <div className="p-3">
            <DettaglioRetribuzione
                dettagliContratto={dettagliContratto}
                dettagliRetribuzione={resource}
                onCancel={cancel}
                mostraRetribOraria={retribOraria}
                toggleRetribOraria={toggleRetribOraria}/>
        </div>}
        <div className="p-3">
            <TabellaMensileRML
                title="Retribuzione Mensile Lorda"
                datasource={retribuzioneFlat}
                pagination={pagination}
                retribOraria={retribOraria}
                toggleRetribOraria={toggleRetribOraria}
                soloVariazioni={soloVariazioni}
                toggleVariazioni={toggleVariazioni}
                URI={URI}
                loadResource={loadResource}
            />
            <div className="mt-3 flex flex-row justify-end">
                <TooltipEx tooltip={`Esporta in un file XLSX l'elenco delle RML`}>
                    <button
                        type="button"
                        className="bg-blue-600 btnPrimary"
                        onClick={exportRML}
                        disabled={exportIsLoading || exportIsFetching}
                    >
                        Export
                    </button>
                </TooltipEx>
            </div>
        </div>
    </>;
}
export default TabFlat;